import styled from 'styled-components';
import {
  DataList,
  DateInput,
  IconButton,
  Input,
  Select,
  StatusLabel,
  TextArea,
} from 'next/components/ui';

export const UpgradeBadge = styled(StatusLabel)`
  font-weight: var(--normal);
  word-break: keep-all;
  user-select: none;
`;

export const ConditionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding-bottom: 16px;

  > ${Select} {
    max-width: unset;
    min-width: unset;
  }
`;

export const Bracket = styled.div`
  align-self: stretch;
  border: 2px solid
    ${({ type }) => (type === 'and' ? 'var(--blurple)' : 'var(--sea-monsters)')};
  border-right-width: 0;
  display: flex;
  margin: 9px 0 20px 0;
  min-width: 45px;
`;

export const BracketWrapper = styled.div`
  align-items: center;
  display: flex;
  min-width: 70px;

  > ${Select} {
    min-width: 70px;
  }

  > ${Bracket} {
    margin-left: -35px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Child = styled.div`
  --options-margin: calc(11em + 12px); // width of first Select + gap

  display: flex;
  justify-content: flex-start;
  gap: 12px;
  position: relative;

  ${Select} {
    min-width: 11em;
    height: 40px;
  }

  ${IconButton} {
    height: 40px;
  }
`;

export const Children = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > ${ConditionsWrapper} {
    padding-bottom: 0;
  }
`;

export const ConditionsType = styled.span`
  align-items: center;
  color: var(--pleather);
  display: flex;
  font-weight: var(--bold);
`;

export const ClauseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;

  ${TextArea} {
    margin-left: calc(-1 * var(--options-margin));
    resize: vertical;
    width: calc(
      100% + var(--options-margin) + 32px
    ); // final value is button width + gap
  }
`;

export const Clause = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${Select} {
    &:first-child {
      min-width: 15em;
    }

    ${UpgradeBadge} {
      margin-top: 6px;
    }
  }

  ${Select}, ${Input}, ${DateInput}, ${DataList} {
    &:nth-last-child(2),
    &:last-of-type {
      min-width: 15em;
    }
  }
`;

export const TimeframeWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  margin-left: calc(-1 * var(--options-margin));

  ${Input}[type=number] {
    width: 6em;
  }

  > ${Select} {
    min-width: 12em;
  }
`;
